import { promises as fs } from 'fs';
import path from 'path';
import MediaToolsPageComponent, { generateMediaToolsProps, MediaToolsPageProps } from '../../components/media-tools/media-tools-page.component';

interface PageProps extends MediaToolsPageProps {
    url: string;
}

export async function getStaticProps() {
    const selectorPath = path.join(process.cwd(), 'public/selector-options/selector-options.json');
    const selectorContents = await fs.readFile(selectorPath, 'utf8');
    const selectorOptions = JSON.parse(selectorContents);

    const mediaToolsProps = generateMediaToolsProps('all-tools', selectorOptions);
    if (!mediaToolsProps) {
        return { notFound: true };
    }

    // Only pull the fields the header/layout needs — avoid spreading the full SSR blob.
    // seoHeaderTagsJson is the page's <title>, meta, canonical and ld+json from xconvert-web-ssr (tools.json);
    // without it _app had none and MediaToolsPageComponent's fallback title/meta replaced the SSR ones
    // (source-of-truth audit 2026-10-10). pageData carries the H1 + subtitle (page_seo.title / .description,
    // xconvert-web-ssr sources/page-data-overrides/tools.json) like the six hub pages; mediaToolsConfig['all-tools']
    // copy is only the fallback for a build without ssr-data (HANDOFF-L4 H6, 2026-10-11).
    let toolsDropdownData = null;
    let environment = null;
    let seoHeaderTagsJson = null;
    let pageData = null;
    try {
        const ssrDataPath = path.join(process.cwd(), 'ssr-data/build/tools.json');
        const ssrData = await fs.readFile(ssrDataPath, 'utf8');
        const ssrProps = JSON.parse(ssrData);
        toolsDropdownData = ssrProps.toolsDropdownData || null;
        environment = ssrProps.environment || null;
        seoHeaderTagsJson = ssrProps.seoHeaderTagsJson || null;
        pageData = ssrProps.pageData || null;
    } catch (e) {
        // SSR data file may not exist
    }

    return {
        props: {
            ...mediaToolsProps,
            toolsDropdownData,
            environment,
            seoHeaderTagsJson,
            pageData,
            url: '/tools',
        }
    };
}

export default function AllToolsPage(props: PageProps) {
    return <MediaToolsPageComponent {...props} />;
}
